import React from 'react';

const Search = ({ className }) => (
  <svg className={className} viewBox='0 0 24 24' fill='none'>
    <path
      fill='currentColor'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.71 14h.79l4.99 5L19 20.49l-5-4.99v-.79l-.27-.28A6.471 6.471 0 019.5
    16 6.5 6.5 0 1116 9.5c0 1.61-.59 3.09-1.57 4.23l.28.27zM5 9.5C5 11.99 7.01
    14 9.5 14S14 11.99 14 9.5 11.99 5 9.5 5 5 7.01 5 9.5z'
    />
  </svg>
);

export default Search;
